import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from '../components/Spinner';
import { useAuth } from '../hooks/useAuth';

export function ProtectedRoute() {
  const { admin, loading } = useAuth();
  if (loading) return <main className="center-page"><Spinner label="Opening your library…" /></main>;
  return admin ? <Outlet /> : <Navigate to="/manage/login" replace />;
}
